import { render, staticRenderFns } from "./SelectProdi.vue?vue&type=template&id=86748dd4"
import script from "./SelectProdi.vue?vue&type=script&lang=js"
export * from "./SelectProdi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports